import { createAsyncThunk } from '@reduxjs/toolkit';
import { AICoachGoalsApi, ParaphraseNextStepResponse } from 'api/AICoachGoalsApi';
import { AICoachGoalDecisionType } from 'enums/AICoach';

import { ErrorResponse } from './ErrorResponse';

export interface ParaphraseNextStepParams {
  applicationId: string;
  recommendedPrimaryGoal: AICoachGoalDecisionType;
}

export const createGetParaphraseNextStepThunk = (api: AICoachGoalsApi) =>
  createAsyncThunk(
    'aiCoachGoals/paraphraseNextStep',
    async ({ applicationId, recommendedPrimaryGoal }: ParaphraseNextStepParams, thunkApi) => {
      try {
        const response: ParaphraseNextStepResponse = await api.paraphraseNextStep(
          applicationId,
          recommendedPrimaryGoal,
        );
        return response;
      } catch (error: unknown) {
        return thunkApi.rejectWithValue((error as ErrorResponse).response.data);
      }
    },
  );
